import type { TaskType } from "./types";

export const TASK_TYPES = {
  CURRENT: "current",
  UPCOMING: "upcoming",
  PAST: "past",
} as const;

export const TAB_CONFIG = [
  { value: TASK_TYPES.CURRENT as TaskType, label: "Current Tasks" },
  { value: TASK_TYPES.UPCOMING as TaskType, label: "Upcoming Tasks" },
  { value: TASK_TYPES.PAST as TaskType, label: "Past Tasks" },
] as const;

export const TABLE_HEADER_CELL_SX = {
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "24px",
  letterSpacing: "0.17px",
  color: "text.primary",
  p: 4,
};

export const TABLE_BODY_CELL_SX = {
  fontSize: "14px",
  lineHeight: "1.43",
  letterSpacing: "0.17px",
  color: "text.primary",
  p: 4,
};
